import * as Yup from 'yup';

export const REVIEW_VALIDATION_SCHEMA = Yup.object().shape({
  name: Yup.string().required('Обязательное поле').max(200, 'Превышено допустимое количество символов'),
  description: Yup.string().required('Обязательное поле').max(500, 'Превышено допустимое количество символов'),
  photo: Yup.object({
    filename: Yup.string().required(),
    signed_id: Yup.string(),
    url: Yup.string(),
  })
    .nullable()
    .test('required', 'Обязательное поле', (value) => value !== null),
});
